import Image from "next/image";
import classNames from "classnames";
import FestivalAllCategory from "@svg/festival-all-category";

interface Props {
  title: string;
  image?: string;
  isActive: boolean;
  isMobile: boolean;
  onClick?: () => void;
  isAll?: boolean;
}

const CategoryCard = ({
  title,
  image,
  isActive,
  isMobile,
  onClick,
  isAll,
}: Props) => {
  const containerClass = classNames(
    "relative flex flex-col items-center text-center transition-all duration-300",
    isMobile
      ? "w-24 basis-24 gap-2 pt-5 pb-3"
      : "w-28 basis-28 gap-4 pt-5 pb-3",
    onClick && "cursor-pointer",
    isActive &&
      !isMobile &&
      'before:content-[""] before:absolute before:bottom-0 before:left-0 before:right-0 before:h-0.5 before:rounded-t-md before:bg-fds-brand-select'
  );

  const imageWrapperClass = classNames(
    "transition-all duration-300",
    isMobile
      ? classNames(
          "w-14 h-14 rounded-full border p-2",
          isActive
            ? "border-fds-brand-select bg-fds-brand-light"
            : "border-transparent bg-fds-secondary"
        )
      : "w-14 h-14"
  );

  const textClass = classNames(
    "h-10 font-medium transition-all duration-300 sm:h-auto",
    isMobile
      ? isActive
        ? "text-xs text-fds-brand-select"
        : "text-xs text-fds-secondary"
      : isActive
        ? "text-sm text-fds-brand-select"
        : "text-sm text-fds-secondary"
  );

  return (
    <button
      type="button"
      onClick={onClick}
      className={containerClass}
      aria-pressed={isActive}
    >
      <div className={imageWrapperClass}>
        {isAll ? (
          <FestivalAllCategory width={isMobile ? 40 : 56} />
        ) : (
          <Image
            width={isMobile ? 40 : 56}
            height={isMobile ? 40 : 56}
            src={image!}
            alt={title}
          />
        )}
      </div>

      <span className={textClass}>{title}</span>
    </button>
  );
};

export default CategoryCard;
